import { render } from "./EquipamentosGruposTabPage.vue?vue&type=template&id=2d7cd293"
import script from "./EquipamentosGruposTabPage.vue?vue&type=script&lang=js"
export * from "./EquipamentosGruposTabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__